import React from 'react';
import { freeBetStore, roundInfoStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { candyDataStore } from '../../../store';
import { GameMainPartsHolder } from '../gameMainPartsHolder';
import { GameMainTop } from '../gameMainTop';
import { GameMainBottom } from '../gameMainBottom';

export const Game = observer(() => {
  const { activeFreeBet } = freeBetStore;
  const { roundId } = roundInfoStore;
  const { zoomAnim, multiplierData, currentWheelType, result } = candyDataStore;
  return (
    <div className='dream-wheel'>
      <GameMainPartsHolder
        zoomAnimData={zoomAnim}
        roundId={roundId}
        currentWheel={currentWheelType}
        wheelsData={result}
      >
        <GameMainTop
          activeFreeBet={activeFreeBet}
          multiplierData={multiplierData}
          zoomAnimData={zoomAnim}
        />
        <GameMainBottom activeFreeBet={activeFreeBet} />
      </GameMainPartsHolder>
    </div>
  );
});
